import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import FactCheckIcon from '@mui/icons-material/FactCheck';

const icoMenu = {
    AssignmentTurnedInIcon,
    FactCheckIcon
};

const arcsaRecepcion = {
    id: 'arcsa_recepcion',
    title: '',
    type: 'group',
    roles: ['Administrador'],
    children: [
        {
            id: 'arcsa_recepcion_menu',
            title: 'Arcsa Recepcion',
            type: 'collapse',
            roles: ['Administrador'],
            icon: icoMenu.AssignmentTurnedInIcon,
            children: [
                {
                    id: 'lista_resultados_recepcion_catalogo',
                    title: 'Resultados Recepcion Catalogo',
                    type: 'item',
                    url: '/user/list-arcsa-recepcion-resultados'
                },
                {
                    id: 'nuevo_resultado_recepcion_catalogo',
                    title: 'Nuevo Resultado Recepcion',
                    type: 'item',
                    url: '/user/new-arcsa-recepcion-resultados/0'
                },
                {
                    id: 'lista_unidades_validar',
                    title: 'Unidades Validar',
                    type: 'item',
                    url: '/user/list-arcsa-recepcion-unidades-validar'
                },
                {
                    id: 'nueva_unidad_validar',
                    title: 'Nueva Unidad Validar',
                    type: 'item',
                    url: '/user/new-arcsa-recepcion-unidades-validar/0'
                },
                {
                    id: 'lista_grupos_parametros_unidad',
                    title: 'Grupos parametros Unidad',
                    type: 'item',
                    url: '/user/list-arcsa-recepcion-grupos-parametros-unidad'
                },
                {
                    id: 'nuevo_grupo_parametros_unidad',
                    title: 'Nuevo Grupo Parametros Unidad',
                    type: 'item',
                    url: '/user/new-arcsa-recepcion-grupos-parametros-unidad/0'
                },
                {
                    id: 'lista_config_recepcion_productos',
                    title: 'Configuracion recepcion productos',
                    type: 'item',
                    url: '/user/list-arcsa-recepcion-config-productos'
                },
                {
                    id: 'nueva_config_recepcion_productos',
                    title: 'Nueva Configuracion recepcion productos',
                    type: 'item',
                    url: '/user/new-arcsa-recepcion-config-productos'
                },
                {
                    id: 'configuracion_reporte_recepcion',
                    title: 'Configuración Reporte',
                    type: 'item',
                    url: '/user/arcsa-recepcion-configuracion-reporte'
                },
                {
                    id: 'lista_tipo_novedades',
                    title: 'Tipo Novedades',
                    type: 'item',
                    url: '/user/list-arcsa-recepcion-tipo-novedades'
                },
                {
                    id: 'lista_tipos_almacenamiento',
                    title: 'Tipos almacenamiento',
                    type: 'item',
                    url: '/user/list-tipos-almacenamiento'
                },
                {
                    id: 'lista_accion_novedades',
                    title: 'Accion novedades',
                    type: 'item',
                    url: '/user/list-arcsa-recepcion-accion-novedades'
                },
                {
                    id: 'lista_motivos_devoluciones_compras',
                    title: 'Motivo devoluciones compras',
                    type: 'item',
                    url: '/user/list-arcsa-recepcion-motivos-devoluciones-compras'
                },
                {
                    id: 'lista_criterios_devoluciones_compras',
                    title: 'Criterios Tecnicos devoluciones compras',
                    type: 'item',
                    url: '/user/list-arcsa-recepcion-criterios-devoluciones-compras'
                },
                {
                    id: 'lista_condiciones_productos_devolucion_ventas',
                    title: 'Condiciones productos devolucion ventas',
                    type: 'item',
                    url: '/user/list-arcsa-recepcion-condiciones-productos-devolucion-ventas'
                },
                {
                    id: 'lista_motivo_devolucion_ventas',
                    title: 'Motivo devolucion ventas',
                    type: 'item',
                    url: '/user/list-arcsa-recepcion-motivo-devolucion-ventas'
                },
                {
                    id: 'lista_evaluacion_devolucion_ventas',
                    title: 'Evaluacion devolucion ventas',
                    type: 'item',
                    url: '/user/list-arcsa-recepcion-evaluacion-devolucion-ventas'
                }
            ]
        }
    ]
};

export default arcsaRecepcion;
